<template>
  <!-- About Section -->
  <!-- About Section -->
  <section id="about" class="about py-5 bg-light">
    <div class="container animate__animated animate__fadeInUp text-center">
      <h2 class="mb-4 text-uppercase fw-bold text-primary">
        <i class="fa fa-anchor me-2"></i>{{ $t('about.title') }}
      </h2>
      <div class="about-content mx-auto">
        <p class="text-muted">{{ $t('about.description') }}</p>
      </div>
    </div>
  </section>
<!-- 🚢 Secțiunea Cruises Danube -->
<section id="cruises" class="cruises py-5 bg-light ">
  <div class="container animate__animated animate__fadeInUp">
    <div class="row align-items-center">
      <!-- 🎥 Videoclip -->
      <div class="col-md-6 text-center mb-3">
        <video controls width="100%" class="shadow-lg rounded">
          <source src="@/assets/video.mp4" type="video/mp4" />
          {{ $t('cruises.videoNotSupported') }}
        </video>
      </div>

      <!-- 📝 Text Cruises Danube -->
      <div class="col-md-6">
        <h2 class="mb-4 text-uppercase fw-bold text-primary text-center">
          <i class="fa fa-ship me-2"></i>{{ $t('cruises.title') }}
        </h2>
        <p class="text-muted">{{ $t('cruises.description') }}</p>
      </div>
    </div>
  </div>
</section>
  <!-- Gallery Section -->
  <section class="gallery py-5">
    <div class="container text-center">
      <h2 class="mb-4 text-uppercase fw-bold text-primary">
        {{ $t('gallery.title') }}
      </h2>
      <div class="row g-4">
        <div class="col-md-4 animate__animated animate__fadeInUp">
          <div class="gallery-item">
            <img src="@/assets/pic01.jpg" :alt="$t('gallery.image1')" class="img-fluid rounded shadow">
            <div class="overlay rounded">
              <p>{{ $t('gallery.image1Desc') }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 animate__animated animate__fadeInUp animate__delay-1s">
          <div class="gallery-item">
            <img src="@/assets/pic02.jpg" :alt="$t('gallery.image2')" class="img-fluid rounded shadow">
            <div class="overlay rounded">
              <p>{{ $t('gallery.image2Desc') }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 animate__animated animate__fadeInUp animate__delay-2s">
          <div class="gallery-item">
            <img src="@/assets/pic03.jpg" :alt="$t('gallery.image3')" class="img-fluid rounded shadow">
            <div class="overlay rounded">
              <p>{{ $t('gallery.image3Desc') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
/* About Section - Îmbunătățiri */
/* Stilizare îmbunătățită pentru About */
.about h2 {
  font-size: 2rem;
  font-weight: bold;
  letter-spacing: 1px;
  margin-bottom: 1rem;
}

/* Conținutul About, pentru a avea o lățime echilibrată */
.about-content {
  max-width: 850px;
  margin: 0 auto;
  font-size: 1.1rem;
  line-height: 1.6;
  text-align: justify;
}

.about p {
  color: #6c757d;
}

/* Gallery Section - Efecte Hover și Modernizare */
.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

.gallery-item img {
  width: 100%;
  border-radius: 12px;
  transition: transform 0.3s ease-in-out;
}

.gallery-item:hover {
  transform: scale(1.03);
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.15);
}

.gallery-item .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .overlay {
  opacity: 1;
}

.gallery-item .overlay p {
  color: white;
  font-size: 1.2rem;
  text-align: center;
  margin: 0;
}
</style>
